import { useRef } from "react";
import { Flex, Box, Text, Divider } from "@chakra-ui/react";
import ButtonPlus from "components/Features/Acordo/NovoAcordo/components/ButtonPlus";
import ImpostosItem from "./ImpostosItem";
import {
  FornecedorImposto,
  FormFornecedorImposto,
} from "core/features/fornecedores/typings/index";
import { UseFormWatch, Control, UseFormSetValue } from "react-hook-form";
import { TipoAliquota } from "ui/components/Input/SelectAliquota/index";

interface ImpostosFormProps {
  control: Control<FornecedorImposto, any>;
  watch: UseFormWatch<FornecedorImposto>;
  setValue: UseFormSetValue<FornecedorImposto>;
}

export default function ImpostosForm({
  control,
  setValue,
  watch,
}: ImpostosFormProps) {
  const tempIdIncrement = useRef(0);

  const impostos = watch("impostos");

  return (
    <Flex flexDir="column" mb="16px">
      <Box w="full">
        <Flex align="center" mb={"32px"}>
          <Text fontSize="18px" fontWeight={"bold"}>
            Impostos
          </Text>

          <ButtonPlus
            onClick={() => {
              setValue("impostos", [
                ...(impostos ?? []),
                {
                  added: true,
                  tempId: `${new Date().getTime().toString()}${
                    tempIdIncrement.current
                  }`,
                  reterImposto: false,
                  aliquotaId: TipoAliquota.Padrao,
                } as FormFornecedorImposto,
              ]);

              tempIdIncrement.current += 1;
            }}
          />
        </Flex>

        <Flex flexDir="column" gap={4}>
          {impostos?.map((imposto: FormFornecedorImposto, index: number) => (
            <>
              <ImpostosItem
                setValue={setValue}
                impostos={impostos}
                key={imposto.added ? imposto.tempId : imposto.id}
                index={index}
                control={control}
              />

              <Divider />
            </>
          ))}
        </Flex>
      </Box>
    </Flex>
  );
}
